import React, { Component } from 'react';
import Banner from '../Common/Banner';

import Slider from 'react-slick';

import DocumentMeta from 'react-document-meta';

class Repair extends React.Component {
	render() {
		
		let settings = {
			dots: false,
			autoplay:true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
		};

		const meta = {
			title: 			'Hurtig og sikker service, så er du på banen igen',
			description: 	'Vi hjælper gerne i alle områder for at vælge den cykel som kan opfylde din drøm. Vi vælger vores sortiment forsigtigt og tester produkterne, alt for at få dig til at føle dig tryg ved dit køb.',
			canonical: 		window.location.href,
			meta: {
				charset: 	'utf-8',
				name: {
					keywords: 'cycle repair copenhagen, bike repair shop, bike service, cheap bike repair'
				}
			}
	    };

		return (
			<div className="main-content" id="repair-page">
                
                <DocumentMeta {...meta} />

				<Banner 
					pageName='Værksted' 
					pageID='repair' 
					pageDesc='Hurtig og sikker service, så er du på banen igen' 
					url='http://res.cloudinary.com/dttrnjoc5/image/upload/c_fill,h_800,q_70/v1510589481/backgrounds/maxresdefault.jpg' />

				<div className="scroll-stop"></div>




				<div className="container">					
					<div className="service-slider-container">
                    	<div className="left-content">
                    		<div className="service-text-wrapper">
                    			
                    			<p>Vi hjælper gerne i alle områder for at vælge den cykel som kan opfylde din drøm. Vi vælger vores sortiment forsigtigt og tester produkterne, alt for at få dig til at føle dig tryg ved dit køb.</p>
                    			<p>Vi tilbyder en lang række reparationer i vores moderne værksted, hvor jeres brugte cykler kan repareres, lappes og eftersynes af vores erfarne medarbejdere, nemt og bekvemt. I vores værksted tilbyder vi alle former for reparationer. Vi har en bred vifte af reservedele og mere end 15 års erfaring.</p>
                    		</div>
                    	</div>
                    	<div className="right-content">
                			<Slider {...settings} className="service-slider">									
								<div className="image-slider">
									<div className="inner">
										<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/c_fit,h_400,q_90,w_600/v1509205791/services/22851380_10214552116380408_1479768585_o.jpg" />					
									</div>
								</div>
								
								<div className="image-slider">
									<div className="inner">
										<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/c_fit,h_400,q_90,w_600/v1509205791/services/22883905_10214552115820394_523012815_o.jpg" />					
									</div>
								</div>
								<div className="image-slider">
									<div className="inner">
										<img src="https://res.cloudinary.com/dttrnjoc5/image/upload/c_fit,h_400,q_90,w_600/v1509205791/services/22878997_10214552117260430_2147055083_o.jpg" />					
									</div>
								</div>
							</Slider>
                		</div>
                    </div> 
                </div> 

				<div className="container">
					<header className="header header-main row">
                        <h2 className="col-md-12">
                        	Komplet Service
                        	<p>Velegnet til dem, der ønsker en god service / gennemgang af din cykel til forår og sommer.</p>
                        </h2>
                    </header>                                   
   
					<div className="row margin-top-30">
						<div className="col-sm-6 col-md-8">							
							<div className="sec-sec-head">Pris 390kr. og inkluderer følgende:</div>
							<div className="service-box-container">
								<div className="service-box">
									<h3>1 - Kontrol af dæk og dæktryk.</h3>
								</div>
								<div className="service-box">
									<h3>2 - Udsigt over pedaler og smøring.</h3>
								</div>
								<div className="service-box">
									<h3>3 - Af kabler og ledninger og smøring.</h3>
								</div>
								<div className="service-box">
									<h3>4 - klemkæde og smøring med specialolie.</h3>
								</div>
								<div className="service-box">
									<h3>5 - Gearjustering.</h3>
								</div>
								<div className="service-box">
									<h3>6 - Visning af kæden.</h3>
								</div>
								<div className="service-box">
									<h3>7 - Kontroller støtte og smøring.</h3>
								</div>
								<div className="service-box">
									<h3>8 - Justering af bremser.</h3>
								</div>
								<div className="service-box">
									<h3>9 - Udsigt over den øvre kurv, sadlen, stativerne og skruerne.</h3>
								</div>
								<div className="service-box">
									<h3>10 - Nemmere tørring og rengøring af groft snavs.</h3>
								</div>
								<div className="service-box">
									<h3>11 - Smøring af lås.</h3>
								</div>
								<div className="service-box">
									<h3>12 - Kontrol af konditionering, bremse og sikkerhed.</h3>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-md-4">
							<div className="sec-sec-head margin-top-35">Hjul og Dæk:</div>
							<p>Har du haft en ulykke med punktering? Fungerer hjulet / hjulene ikke korrekt? Kom ind med din cykel, vi tager os af det. Til din fordele , vi kan fikse fejlen, mens du venter. Denne service kan indholde følgende tjenster.</p>
							<div className="sec-sec-head margin-top-30">Eftersyn Pris :170kr.</div>
							<div className="sec-sec-head margin-top-30">Udskiftning af slange: 150kr.</div>
						</div>
					</div>

					<div className="margin-top-80 visible-xs"></div>

				</div>
				

			</div>
		);
	}
}

export default Repair;



// WEBPACK FOOTER //
// ./src/Pages/Repair.js